import { c as _c } from "react/compiler-runtime";
import { ReserveBookingCardWrapperType } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card-wrapper/hotel-reserve-booking-card-wrapper.type";
import { FC } from "react";
export const HotelReserveBookingCardWrapper: FC<ReserveBookingCardWrapperType> = properties => {
  const $ = _c(3);
  const {
    classes: t0,
    children
  } = properties;
  const classes = t0 === undefined ? "" : t0;
  const t1 = `border-outline-thin size-full rounded-xl border bg-white lg:block ${classes}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};